"use client";

import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldAlertIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppEvent } from "@/lib/events";

/**
 * Surfaced when any /api/* call returns 403 (authenticated but not authorized
 * for the action). Mirrors the quota-exceeded modal so users keep their route
 * context instead of being kicked back to /login on a permission denial.
 */
export function ForbiddenActionDialog() {
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState<string | undefined>(undefined);
  const { t } = useTranslation();

  useAppEvent("forbidden-action", (payload) => {
    setDetail(payload?.detail);
    setOpen(true);
  });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent showCloseButton>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldAlertIcon className="size-5 text-destructive" />
            {t("forbidden.title")}
          </DialogTitle>
          <DialogDescription>
            {detail ?? t("forbidden.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            {t("common.close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
